import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import ReportTable from './ReportTable';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { TrueImpactTransparentButton } from 'shared/design-system/components/TrueImpactButton';
import { ReportAPIResponse } from '../api';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { Program } from '../../Reports/NewReportDialog';

interface ReportListProps {
  program: Program;
  isAdminUser: boolean;
  reports: ReportAPIResponse[];
  handleAdminModalOpen: (r: ReportAPIResponse) => unknown;
  handleAdminModalClose: () => unknown;
  cloneExistingYear: (year: number) => unknown;
}

const StyledDiv = styled.div`
  .report-list-button {
    margin-left: auto;
    margin-right: auto;
    padding-top: ${SPACERS.tiny};
    padding-bottom: ${SPACERS.tiny};
    margin-top: ${SPACERS.extraLarge};
    margin-bottom: ${SPACERS.medium};
  }
`;

const ReportList: React.FC<ReportListProps> = ({
  reports,
  program,
  isAdminUser,
  handleAdminModalClose,
  handleAdminModalOpen,
  cloneExistingYear,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = useCallback(() => {
    setOpen(o => !o);
  }, [setOpen]);
  if (reports.length === 0) return null;
  return (
    <StyledDiv>
      <TrueImpactTransparentButton
        onClick={handleClick}
        icon={open ? faEyeSlash : faEye}
        className="report-list-button"
      >
        {open ? 'Hide Full Report List' : 'Show Full Report List'}
      </TrueImpactTransparentButton>
      {open && (
        <ReportTable
          reports={reports}
          program={program}
          isAdminUser={isAdminUser}
          handleAdminModalOpen={handleAdminModalOpen}
          handleAdminModalClose={handleAdminModalClose}
          cloneExistingYear={cloneExistingYear}
        />
      )}
    </StyledDiv>
  );
};

export default ReportList;
